export default {
  init() {
    // JavaScript to be fired on the about us page

    // const mapRange = (inputLower, inputUpper, outputLower, outputUpper, value) => {
    //   const INPUT_RANGE = inputUpper - inputLower;
    //   const OUTPUT_RANGE = outputUpper - outputLower;
    //   return (
    //     outputLower + (((value - inputLower) / INPUT_RANGE) * OUTPUT_RANGE || 0)
    //   );
    // };
    //
    // const myCarousel = new Carousel(document.getElementById('myCarousel'), {
    //   Dots: false,
    //   slidesPerPage: 1,
    //   on: {
    //     'Panzoom.beforeTransform': (carousel) => {
    //       carousel.slides.map((slide) => {
    //         const progress = carousel.getProgress(slide.index);
    //         const scale = mapRange(0, 1, 1, 1.2, 1 - Math.abs(progress));
    //
    //         slide.el.style.setProperty('--f-scale', scale);
    //         slide.el.style.setProperty('--f-translateX', `${progress * -10}%`);
    //       });
    //     },
    //   },
    // });
  },
};
